import HeaderComponent from "../components/HeaderComponent";

function ProfilePage() {
    return (
        <>
            <HeaderComponent />
            <h1>Profile Page</h1>
        </>
    );
}

export default ProfilePage;